<template>
<div class="chapter">
<div class="inner_page">
<p class="P_AnthologyTitles"><span> </span></p>
<div style="page-break-before: always;"></div>
<div class="P_Normal__And__Centre_Alignment__And__Page_Break">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><div style="page-break-before: always;"></div>
<p class="P_Normal__And__Centre_Alignment__And__Line_Spacing__And__Page_Break"><span><span style=" font-family: 'Old English Text MT'; font-size: 6.00em;">Dragonesque</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span><span style=" font-size: 0.83em;">Edited by</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"><span><span style=" font-size: 0.83em;">S.C. Butler</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"><span><span style=" font-size: 0.83em;">&amp;</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"><span><span style=" font-size: 0.83em;">Joshua Palmatier</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span><span style=" font-size: 0.83em;">Zombies Need Brains LLC</span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span><span style=" font-size: 0.83em;"><a href="http://www.zombiesneedbrains.com" target="_blank">www.zombiesneedbrains.com</a></span></span></p>
</div></div>
<div class="P_Normal__And__Centre_Alignment">
<div class="B_Box1" style="display:inline-block;margin-left:auto;margin-right:auto;"><p class="P_Normal__And__Centre_Alignment__And__Line_Spacing"><span> </span></p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?258d9242